import { Action } from '@ngrx/store';
import { AddUpdateDeviceParams, MiniCardWithoutPackParams} from '../../../models/devices';

export enum BindDeviceActionTypes {
  LoadBindDevices = '[BindDevice] Load BindDevices',
  GetBindDevices = '[BindDevice] Get BindDevices',
  GetBindDevicesWithoutPack = '[BindDevice] Get BindDevices Without Pack'
}

export class LoadBindDevices implements Action {
  readonly type = BindDeviceActionTypes.LoadBindDevices;
}

export class GetBindDevices implements Action {
  readonly type = BindDeviceActionTypes.GetBindDevices;
  constructor(public payload: AddUpdateDeviceParams) {}
}

export class GetBindDevicesWithoutPack implements Action {
  readonly type = BindDeviceActionTypes.GetBindDevicesWithoutPack;
  constructor(public payload: MiniCardWithoutPackParams) {}
}


export type BindDeviceActions = LoadBindDevices
  | GetBindDevices
  | GetBindDevicesWithoutPack;
